/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  EvaluationDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EvaluationDtoFromJSON,
    EvaluationDtoToJSON,
} from '../models/index';

export interface EvaluateRequest {
    evaluationDto: EvaluationDto;
}

/**
 * 
 */
export class DunningEvaluationApi extends runtime.BaseAPI {

    /**
     * This query allows you to evaluate a list of contracts to determine whether dunning notifications need to be sent
     * Evaluation of Individual Contracts
     */
    async evaluateRaw(requestParameters: EvaluateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.evaluationDto === null || requestParameters.evaluationDto === undefined) {
            throw new runtime.RequiredError('evaluationDto','Required parameter requestParameters.evaluationDto was null or undefined when calling evaluate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/evaluate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EvaluationDtoToJSON(requestParameters.evaluationDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * This query allows you to evaluate a list of contracts to determine whether dunning notifications need to be sent
     * Evaluation of Individual Contracts
     */
    async evaluate(requestParameters: EvaluateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.evaluateRaw(requestParameters, initOverrides);
    }

}
